import React, { useCallback } from 'react';
import { NotificationTemplateEntity } from 'src/firebase/db/NotificationTemplates';

import NotificationTemplateListItem from 'src/components/molecules/list/NotificationTemplateListItem';

interface Props {
  notificationTemplates: NotificationTemplateEntity[];
  isCheckedTemplates: { id: string; checked: boolean }[];
  isExpiredTime: (timestamp?: Date) => boolean;
  onConfirm: (notificationTemplateId: string) => void;
  onDelete: (notificationTemplateId: string) => void;
  onEdit: (notificationTemplateId: string) => void;
  onCheck: (notificationTemplateId: string) => void;
}

export const NotificationTemplateList = ({ ...props }: Props) => {
  const {
    notificationTemplates,
    isCheckedTemplates,
    isExpiredTime,
    onConfirm,
    onDelete,
    onEdit,
    onCheck,
  } = props;

  const isChecked = useCallback(
    (notificationTemplateId: string) => {
      const v = isCheckedTemplates.find((v) => v.id === notificationTemplateId);
      return v ? v.checked : false;
    },
    [isCheckedTemplates],
  );

  return (
    <div>
      {notificationTemplates.map((notificationTemplate) => (
        <NotificationTemplateListItem
          key={notificationTemplate.id}
          notificationTemplate={notificationTemplate}
          isExpiredTime={isExpiredTime(notificationTemplate.scheduled_time)}
          isChecked={isChecked(notificationTemplate.id)}
          onConfirm={onConfirm}
          onDelete={onDelete}
          onEdit={onEdit}
          onCheck={onCheck}
        />
      ))}
    </div>
  );
};

export default NotificationTemplateList;
